import { Outlet } from 'react-router';
import { Hreflang } from '@components/seo/Hreflang';
import Header from '@layouts/main-layout/header/Header';
import Footer from '@layouts/main-layout/footer/Footer';
import { PaymentInfo } from '@layouts/main-layout/payment-info/PaymentInfo';
import SideElement from '@layouts/main-layout/side-element/SideElement';
import ErrorBoundary from '@components/error-boundary/ErrorBoundary';



const MainLayout = () => {

	return (
		<ErrorBoundary>
			
			<div className="app-main-layout">

				<Hreflang />

				<Header />
				
				<Outlet />

				<Footer />

				<PaymentInfo />

			</div>

			<SideElement />
		
		</ErrorBoundary>
	);
};

export default MainLayout;